import confetti from 'canvas-confetti'

const defaults = { origin: { y: 0.7 }, zIndex: 9999 }

export function triggerConfetti(type = 'default') {
    const configs = {
        cardDone: { particleCount: 80, spread: 60, colors: ['#7c3aed', '#ec4899', '#10b981'] },
        targetMet: { particleCount: 120, spread: 100, colors: ['#10b981', '#7c3aed'] },
        levelUp: { particleCount: 150, spread: 120, colors: ['#f59e0b', '#7c3aed', '#ec4899'] },
        badge: { particleCount: 100, spread: 80, colors: ['#ec4899', '#7c3aed', '#3b82f6'] },
        default: { particleCount: 50, spread: 70 }
    }
    const opts = { ...defaults, ...configs[type] }
    confetti(opts)
}
